<script>
	import {
		faEye as fasEye,
		faEyeSlash as fasEyeSlash,
	} from "@fortawesome/free-solid-svg-icons";
	import FontAwesomeIcon from "src/components/FontAwesomeIcon/FontAwesomeIcon.svelte";
	import { brand } from "src/brand";
	import AuthScreenBrand from "src/components/AuthScreenBrand/AuthScreenBrand.svelte";
	import ButtonWrapper from "src/components/ButtonWrapper/ButtonWrapper.svelte";
	import { navigate } from "svelte-routing";
	import { Button, Label } from "@sveltestrap/sveltestrap";
	import CustomInput from "../components/CustomInput/CustomInput.svelte";
	import ErrorMessageHandler from "../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import { doLogin, doLoginAsWorkshop } from "../store/auth/auth";
	import { errorMessage, loading, successMessage } from "../store/store";
	import { isWshopLoginBypassEnabled } from "src/config/flag-config";
	let email = "";
	let password = "";
	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
	async function submit() {
		doLogin({ email, password });
	}
	let load;
	loading.subscribe((value) => {
		load = value;
	});

	const handleNavigate = (value) => {
		errorMessage.set("");
		successMessage.set("");
		navigate("forgot-password");
	};

	let show = false;

	const handleShow = () => {
		if (show) {
			show = false;
		} else {
			show = true;
		}
	};

	const onKeyPress = (e) => {
		if (e.charCode === 13) submit();
	};
</script>

<main>
	<div class="main-container">
		<AuthScreenBrand />
		<div class="right">
			<div class="sign-in">
				<h2>{brand.platformName}</h2>
				<ErrorMessageHandler message={err} />
				<div class="mt-3 mb-1">
					<Label for="email">
						<b>Email</b>
					</Label>
				</div>
				<div>
					<CustomInput id="email" type="email" bind:value={email} />
				</div>
				<div class="mt-3 mb-1">
					<Label for="password">
						<b>Password</b>
					</Label>
				</div>

				<div class="position-relative">
					<CustomInput
						id="password"
						type={!show ? "password" : "text"}
						bind:value={password}
						keypress={onKeyPress}
					/>
					<span
						class="text-count"
						style="
                            position: absolute;
                            bottom: 27%;
                            right: 18px;"
					>
						<ButtonWrapper
							onClick={handleShow}
							onKeyDown={() => {}}
							on:keydown={() => {}}
						>
							{#if show}
								<FontAwesomeIcon icon={fasEye} />
							{:else}
								<FontAwesomeIcon icon={fasEyeSlash} />
							{/if}
						</ButtonWrapper>
					</span>
				</div>
				<div />
				<div class="forgot my-4">
					<ButtonWrapper
						onClick={handleNavigate}
						onKeyDown={() => {}}
						on:keydown={() => {}}
					>
						<b class="link font-weight-bold"> Forgot password? </b>
					</ButtonWrapper>
				</div>
				{#if !load}
					<div class="my-2">
						<Button
							block
							class="themeButton primary"
							on:click={submit}
							disabled={load || !email || !password}
						>
							Log in
						</Button>
					</div>
				{:else}
					<div class="my-2">
						<Button
							block
							class="themeButton primary"
							type="button"
							disabled
						>
							<output
								class="spinner-grow spinner-grow-sm"
								aria-hidden="true"
							/>
							Signing you in...
						</Button>
					</div>
				{/if}
				{#if isWshopLoginBypassEnabled}
					<div class="my-2">
						<Button
							block
							class="themeButton backButton"
							type="button"
							on:click={doLoginAsWorkshop}
						>
							Log in as Workshop
						</Button>
					</div>
				{/if}
			</div>
		</div>
	</div>
</main>
